import { z } from "zod";

export const SP_API_OAUTH_MESSAGE_TYPE = "sp-api-oauth-result" as const;

export const spApiOAuthResultMessageSchema = z.discriminatedUnion("success", [
  z.object({
    type: z.literal(SP_API_OAUTH_MESSAGE_TYPE),
    success: z.literal(true),
    connectionId: z.string().uuid(),
  }),
  z.object({
    type: z.literal(SP_API_OAUTH_MESSAGE_TYPE),
    success: z.literal(false),
    errorCode: z.string().trim().min(1).max(160),
  }),
]);

export type SpApiOAuthResultMessage = z.infer<typeof spApiOAuthResultMessageSchema>;

/** Relay only the validated outcome and pin delivery to the current AdPraxis origin. */
export function notifySpApiOAuthOpener(
  opener: Pick<Window, "postMessage">,
  origin: string,
  result: SpApiOAuthResultMessage,
): void {
  opener.postMessage(result, origin);
}

/** Accept OAuth results only from the exact popup opened by this page on this origin. */
export function parseTrustedSpApiOAuthMessage(
  event: Pick<MessageEvent, "data" | "origin" | "source">,
  expectedOrigin: string,
  expectedSource: Window,
): SpApiOAuthResultMessage | null {
  if (event.origin !== expectedOrigin || event.source !== expectedSource) return null;
  const parsed = spApiOAuthResultMessageSchema.safeParse(event.data);
  return parsed.success ? parsed.data : null;
}

/** Full-page fallback after OAuth uses the same Settings result handling as a popup success. */
export function spApiSettingsLandingUrl(result: SpApiOAuthResultMessage): string {
  const search = new URLSearchParams({ tab: "amazon" });
  if (result.success) {
    search.set("sp_api", "connected");
    search.set("sp_api_connection", result.connectionId);
  } else {
    search.set("sp_api_error", result.errorCode);
  }
  return `/settings?${search.toString()}`;
}
